const config={
  api:{
    contact: "/api/contact"
  },
  format:{
    date:{
      display:"MM月DD日",
      date:"YYYY-MM-DD"
    }
  },
  monthlyCost:{
    plans:[
      {'10G': 69, '20G': 79, '30G': 89},
      {'10G': 49, '20G': 59, '30G': 69},
      {'10G': 39, '20G': 49, '30G': 59},
    ],
    patterns:[0,0,0,1,1,1,1,1,2,2,2,2],
    simple:[
      {key: 'group1', label: '1-3ヶ月', group:0},
      {key: 'group2', label: '4-8ヶ月', group:1},
      {key: 'group3', label: '9-12ヶ月', group:2}
    ]
  },
  delivery_date:{
    au: 8,
    jp: 21
  },
  labels:{
    step1:{
      title:'サービスの選択'
    },
    initialCost:{
      title: "初期費用",
      fixed: [
        {label: "クレジットカード登録費用", cost: 10},
        {label: "SIMカード発行事務手数料", cost: 20},
      ],
    },
    monthlyCost:{
      title: "毎月の費用"
    }
  },
  fields:{
    product_type: {
      name: "product_type",
      label: "サービスの種類",
      options: {},
      items: [
        {value:'sim_only',        label:'自分の携帯を使う', icon:'save', tip: 'ご契約の携帯会社にて必ずSIMロックを解除してもらった機種をご利用ください。SIMカードは標準、ミクロ、ナノの3つのサイズに対応しています。' },
        {value:'sim_plus_device', label:'新しい携帯を購入する', icon:'mobile',  tip: 'こちらを選択すると、購入可能な機種が表示されます。ご希望の機種を選択してください！' }
      ]
    },
    device: {
      name: "device",
      label: "ご希望機種",
      options: {},
      items: [
        { id: "xperia-xa", name: "Xperia XA", price: "250", maker:"Sony",
          thumb: '/v2/images/mobile/simulator/xperia-min.png',
          desc: '安心の日本ブランド。操作画面の反応速度はトラトラ携帯の中でもピカイチ。初期アプリも充実のたっぷり8GBメモリで、カメラ機能もトップを誇る。',
          tags: ['回線 4G/LTE', '容量 16GB','画面 5インチ','カメラ 13MP', 'SIMアンロック','日本語設定', '日本語入力', 'テザリング可']
        },
        { id: "huawai-y6", name: "Y6", price: "139", maker:"Huawai",
          thumb:'/v2/dest/images/mobile/simulator/huawei-min.png',
          desc: 'オーストラリアに半年以上滞在するWH生や学生からの支持が厚い携帯電話。価格もグレードも平均的で、全体を取っても平均的なスマートフォン。',
          tags: ['回線 4G/LTE', '容量 8GB','画面 5インチ','カメラ 5MP', 'SIMアンロック','日本語設定', '日本語入力', 'テザリング可']
        },
        { id: "desire-510", name: "DESIRE 510", price: "169", maker:"HTC",
          thumb:'/v2/dest/images/mobile/simulator/htc-min.png',
          desc:'オーストラリア国内で支持率の高いHTC。ショートカット操作が充実してるので、普段から携帯よりもパソコンに慣れている人におすすめの携帯電話。',
          tags: ['回線 4G/LTE', '容量 8GB','画面 4.7インチ','カメラ 5MP', 'SIMアンロック','日本語設定', '日本語入力', 'テザリング可']
        },
        { id: "iphone-se16g", name: "iPhone SE 16G", price: "679", maker:"Apple",
          thumb:'/v2/dest/images/mobile/simulator/iphone-se-min.png',
          desc:'日本で人気の高いiPhoneは、最新のSE機種でのご案内。片手に収まるサイズでカメラ機能は圧倒の1,200万画素！',
          tags: ['回線 4G/LTE', '容量 16GB','画面 4インチ','カメラ 12MP', 'SIMアンロック','日本語設定', '日本語入力', 'テザリング可']
        },
        { id: "iphone-se64g", name: "iPhone SE 64G", price: "829", maker:"Apple",
          thumb:'/v2/dest/images/mobile/simulator/iphone-se-min.png',
          desc:'日本で人気の高いiPhoneは、最新のSE機種でのご案内。片手に収まるサイズでカメラ機能は圧倒の1,200万画素！',
          tags: ['回線 4G/LTE', '容量 64GB','画面 4インチ','カメラ 12MP', 'SIMアンロック','日本語設定', '日本語入力', 'テザリング可']
        }
      ]
    },
    term: {
      name: "term",
      label: "ご使用予定期間",
      options: {},
      /*
      items: [
        {value:'1', label:'1ヶ月' },
        {value:'2', label:'2ヶ月' },
        {value:'3', label:'3ヶ月' },
        {value:'4', label:'4ヶ月' },
        {value:'5', label:'5ヶ月' },
        {value:'6', label:'6ヶ月' },
        {value:'7', label:'7ヶ月' },
        {value:'8', label:'8ヶ月' },
        {value:'9', label:'9ヶ月' },
        {value:'10', label:'10ヶ月' },
        {value:'11', label:'11ヶ月' },
        {value:'12', label:'12ヶ月' },
      ]*/
      items:{
        0: {label: '', value:0},
        1: {label: '1ヶ月', value:1},
        2: {label: '2', value:2},
        3: {label: '3', value:3},
        4: {label: '4', value:4},
        5: {label: '5', value:5},
        6: {label: '6', value:6},
        7: {label: '7', value:7},
        8: {label: '8', value:8},
        9: {label: '9', value:9},
        10:{label: '10', value:10},
        11:{label: '11', value:11},
        12:{label: '12', value:12},
      },
    },
    plan: {
      name: "plan",
      label: "データプラン",
      options: {},
      items: [
        {value:'10G', label:'10G',
          title: 'プラン',
          detail: [
            {label:'利用国',value:'オーストラリア国内のみ'},
            {label:'利用期間	',value:'10ヶ月以上'},
            {label:'データ容量',value:'10GB（10000MB）'},
            {label:'データ超過料金',value:'1MBにつき$0.01ドル'},
            {label:'国内通話料金',value:'$1/分＋接続料(通話オプション有)'},
            {label:'日本への国際電話',value:'$1/分＋接続料金'},
            {label:'接続料金	',value:'$0.25/通話'},
            {label:'電話の着信',value:'国際/国内ともに無料です'},
            {label:'国際SMSメール',value:'$0.55/通'},
            {label:'MMSメール',value:'$0.55/通'},
            {label:'早期解約	',value:'月額ｘ残りの契約期間'},
            {label:'プラン変更',value:'契約満了前のプラン変更は$50'},
            {label:'SIM再発行料金',value:'1回目無料、2回目＄50（送料込）'}
          ]
        },
        {value:'20G', label:'20G',
          title: 'プラン',
          detail: [
            {label:'利用国',value:'オーストラリア国内のみ'},
            {label:'利用期間	',value:'10ヶ月以上'},
            {label:'データ容量',value:'20GB（20000MB）'},
            {label:'データ超過料金',value:'1MBにつき$0.01ドル'},
            {label:'国内通話料金',value:'$1/分＋接続料(通話オプション有)'},
            {label:'日本への国際電話',value:'$1/分＋接続料金'},
            {label:'接続料金	',value:'$0.25/通話'},
            {label:'電話の着信',value:'国際/国内ともに無料です'},
            {label:'国際SMSメール',value:'$0.55/通'},
            {label:'MMSメール',value:'$0.55/通'},
            {label:'早期解約	',value:'月額ｘ残りの契約期間'},
            {label:'プラン変更',value:'契約満了前のプラン変更は$50'},
            {label:'SIM再発行料金',value:'1回目無料、2回目＄50（送料込）'}
          ],
        },
        {value:'30G', label:'30G',
          title: 'プラン',
          detail: [
            {label:'利用国',value:'オーストラリア国内のみ'},
            {label:'利用期間	',value:'10ヶ月以上'},
            {label:'データ容量',value:'30GB（30000MB）'},
            {label:'データ超過料金',value:'1MBにつき$0.01ドル'},
            {label:'国内通話料金',value:'$1/分＋接続料(通話オプション有)'},
            {label:'日本への国際電話',value:'$1/分＋接続料金'},
            {label:'接続料金	',value:'$0.25/通話'},
            {label:'電話の着信',value:'国際/国内ともに無料です'},
            {label:'国際SMSメール',value:'$0.55/通'},
            {label:'MMSメール',value:'$0.55/通'},
            {label:'早期解約	',value:'月額ｘ残りの契約期間'},
            {label:'プラン変更',value:'契約満了前のプラン変更は$50'},
            {label:'SIM再発行料金',value:'1回目無料、2回目＄50（送料込）'}
          ],
        }
      ]
    },
    delivery_method: {
      name: "delivery_method",
      label: "受取方法",
      options: {},
      items: [
        { value:'au',
          label:'オーストラリアへ郵送',
          thumb: "/flags/4x3/au.svg",
          conds: [{'sim_only': 0}, {'sim_plus_device': 0}],
          tip:'オーストラリア滞在先へ郵送します。オーストラリア国内でSIＭカード/機種を郵送する場合、日本出発２週間前のオンライン申し込みが必要です。すでにオーストラリアに到着されている場合でもオンラインよりお申し込みが可能です。', },
        { value:'jp',
          label:'日本へ郵送',
          thumb: "/flags/4x3/jp.svg",
          conds: [{'sim_only': 0}, {'sim_plus_device': 150}],
          tip: '日本への機種を郵送する場合、機材はすべてオーストラリアから発送されますので、発送準備と郵送期間を含めますと、日本出発3週間前のオンライン申し込みが必要です。'}
      ]
    },
    name: {
      name: "name",
      label: "お名前（ローマ字）",
      options: {
        rules: [{
          required: true,
          message: 'お名前を入力してください',
        }],
      }
    },
    email: {
      name: "email",
      label: "Email",
      options: {
        rules: [{
          type: 'email',
          message: '有効なEmailアドレスを入力して下さい',
        }, {
          required: true,
          message: 'Emailアドレスを入力して下さい。',
        }],
      }
    },
    phone: {
      name: "phone",
      label: "電話番号",
      options: {}
    },
    address: {
      name: "address",
      label: "送付先住所",
      options: {}
    },
    tba: {
      name: "tba_address",
      label: "住所を後で知らせる",
      options: {}
    },
    self_pickup: {
      name: "self_pickup",
      label: "トラトラシドニー店頭でピックアップする",
      options: {}
    },
    enquiry: {
      name: "enquiry",
      label: "お問い合わせ",
      options: {}
    },
    payment: {
      name: "payment",
      label: "お支払い",
      options: {}
    },
    arrival: {
      name: "arrival",
      label: "入国予定日",
      options: {}
    },
    card_no: {
      name: "card_no",
      label: "カード番号",
      options: {
        rules: [{
          required: true,
          message: 'カード番号を入力して下さい',
        },{
          type: 'string',
//          pattern: /^[\d\-]+$/,
          message: '有効なカード番号を入力して下さい',
        }],
      }
    },
    card_expiry: {
      name: "card_expiry",
      label: "カード期限",
      options: {}
    },
    card_cvc: {
      name: "card_cvc",
      label: "CVC番号",
      options: {}
    },

    /*
    deliver_method:[
      {value:'tora', label:'トラトラ(シドニー)受取'},
      {value:'japan', label:'日本の自宅へ郵送'},
      {value:'australia', label:'滞在先へ郵送'},
    ]
    */
  },
};

export default config;


// WEBPACK FOOTER //
// ./src/pages/mobile/config/config.js